import React from "react";

import {
  ConfigureIntegrationsModal,
  DEST_INTEGRATION,
} from "./ConfigureIntegrationModal";

function ConfigureDestinationsModal(props) {
  return (
    <ConfigureIntegrationsModal
      integration={props.dest}
      integrationType={DEST_INTEGRATION}
      {...props}
    />
  );
}

export { ConfigureDestinationsModal };
